import { Component, OnInit, ChangeDetectorRef, inject} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Grupo } from '../../../../../models/parametros.model';
import { ParametrosService } from '../../../../../services/parametros.service';

@Component({
  selector: 'app-grupo-manutencao',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './grupo-manutencao.component.html',
  styleUrls: ['./grupo-manutencao.component.css']
})


export class GrupoManutencaoComponent implements OnInit {
  grupo: Grupo = { id: 0, nome: '', createdAt: '' };
  isEditMode = false;

  constructor(
    private parametrosService: ParametrosService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

 private cdr = inject(ChangeDetectorRef);


  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.isEditMode = true;
      this.parametrosService.getGrupo(+id).subscribe(data => {
        this.grupo = data;
        this.cdr.detectChanges();
      });
    }
  }

  save(): void {
    if (this.isEditMode) {
      this.parametrosService.updateGrupo(this.grupo).subscribe(() => {
        this.router.navigate(['/home', 'parametro-despesa-grupo']);
      });
    } else {
      this.parametrosService.createGrupo(this.grupo).subscribe(() => {
        this.router.navigate(['/home', 'parametro-despesa-grupo']);
      });
    }
  }

  cancel(): void {
    this.router.navigate(['/home', 'parametro-despesa-grupo']);
  }
}
